import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { ClausesComponentVM } from 'ent-components-platform-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { LoadSaveService } from 'twia-capability-quoteandbind-residential';
import { GatewayRenewalService as RenewalService} from 'gw-capability-gateway-policyrenewal';
import { GatewayEndorsementService as ChangeService } from 'twia-capability-gateway-policychange';
import metadata from './CoveragesAccordion.metadata.json5';
import styles from './CoveragesAccordion.module.scss'


function CoveragesAccordion(props) {
    const { data: coverages, path: coveragePath, onValueChange,
        policyDetailsData,
        lobData_TWIA,
        policyTransactionDetails, policyTransactionData, renewalData } = props;

    const [initialSubmission, setInitialSubmission] = useState(null);
    const authHeader = _.get(useAuthentication(), 'authHeader');
    const viewModelService = useContext(ViewModelServiceContext);

    useEffect(() => {

        // retrieveSubmission() // DE18512

    }, [])

    const retrieveSubmission = () => {
        if (authHeader) {
            // DE16733
            const jobType = _.find(policyTransactionData, (job)=>job.displayType==='Submission')
            let quoteID = jobType?.jobNumber || renewalData?.jobNumber
            const postalCode = _.get(policyDetailsData, 'account.accountHolder.primaryAddress.postalCode')
            const requestData = { quoteID, postalCode }

            if (jobType?.type === 'Submission' && policyDetailsData.latestPeriod.jobType_TWIA === 'Submission') {
                LoadSaveService.retrieveSubmission(requestData, authHeader).then((response) => {
                    const responseSubmission = viewModelService.create(
                        response,
                        'pc',
                        'edge.capabilities.quote.submission.dto.QuoteDataDTO');

                    setInitialSubmission(responseSubmission);
                })
            } 
            else if (policyDetailsData?.latestPeriod?.jobType_TWIA === 'PolicyChange') {
                const jobNumber = _.get(policyDetailsData, 'latestPeriod.policyNumber')

                ChangeService.loadEndorsement(jobNumber, authHeader).then((response) => {
                    const responseSubmission = viewModelService.create(
                        response,
                        'pc',
                        'edge.capabilities.policychange.dto.PolicyChangeDataDTO')

                    setInitialSubmission(responseSubmission);
                })
            }
            else {
                if(!renewalData){
                    const jobData = _.find(policyTransactionData, (job)=>job.displayType === 'Renewal');

                    quoteID = jobData?.jobNumber
                }

                if(quoteID) {
                    RenewalService.loadRenewal(quoteID, authHeader).then((response) => {
                        const responseSubmission = viewModelService.create(
                            response,
                            'pc',
                            "edge.capabilities.renewal.dto.RenewalDataDTO"
                        );
    
                        setInitialSubmission(responseSubmission);
                    })
                }
            }
    }
    }

    const renderValueField = useCallback((rowData, rowIndex) => (
        <CurrencyField
            id={`creditAmount_${rowIndex}`}
            value={rowData.amount}
            readOnly
            hideLabel
        />
    ), []);

    const renderNameField = useCallback((rowData) => <span>{rowData.name}</span>, []);

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
        },
        baseCoveragesComponent: {
            value: _.get(lobData_TWIA, 'homeOwners.baseCoverages_TWIA'),
            path: 'homeOwners.baseCoverages_TWIA',
            // initialSubmission,
            additionalFieldsPath: "homeOwners.additionalCoverages_TWIA",
            // eslint-disable-next-line no-secrets/no-secrets
            // disableAdditionalFields: _.get(initialSubmission, 'lobData.value.homeowners.coverables.construction.msbEligiblePolicyType_TWIA'),
            loadingClause: true,
            isComponentValid: true,
            showError: false,
            showAdditionalFieldError: false,
            isEditable: false,
            isResidentialSummary: true,
            labelPosition: false,
            showAmount: true,
            showCoverageNameAmount: false
        },
        additionalCoveragesComponent: {
            value: _.get(lobData_TWIA, 'homeOwners.additionalCoverages_TWIA'),
            path: "homeOwners.additionalCoverages_TWIA",
            loadingClause: true,
            isComponentValid: true,
            showError: false,
            showAdditionalFieldError: false,
            isEditable: false,
            isResidentialSummary: true,
            labelPosition: true,
            showAmount: true,
            showCoverageNameAmount: false // DE17056
        },
        exclusionConditionsComponent: {
            value: _.get(lobData_TWIA, 'homeOwners.exclusions_TWIA'),
            path: "homeOwners.exclusions_TWIA",
            loadingClause: true,
            isComponentValid: true,
            showError: false,
            showAdditionalFieldError: false,
            isEditable: false,
            isResidentialSummary: true,
            labelPosition: true,
            showAmount: true,
            showCoverageNameAmount: false
        },
        indirectLossCovComponent: {
            value: _.get(lobData_TWIA, 'homeOwners.indirectLossCoverages_TWIA'),
            path: "homeOwners.indirectLossCoverages_TWIA",
            loadingClause: true,
            isComponentValid: true,
            showError: false,
            showAdditionalFieldError: false,
            isEditable: false,
            isResidentialSummary: true,
            labelPosition: true,
            showAmount: true,
            showCoverageNameAmount: false
        },
        creditSurchargesTitle: {
            // DE15705
            visible:
                _.get(lobData_TWIA, 'homeOwners.creditsAndSurchages_TWIA') !== undefined
        },
        creditAndSurchargesTable: {
            visible:
                _.get(lobData_TWIA, 'homeOwners.creditsAndSurchages_TWIA') !== undefined,
            data: _.get(lobData_TWIA, 'homeOwners.creditsAndSurchages_TWIA')
        },
        totalBaseCovPremium: {
            visible:
                _.get(lobData_TWIA, 'homeOwners.baseCoveragesTotal_TWIA') !== undefined,
            value: _.get(lobData_TWIA, 'homeOwners.baseCoveragesTotal_TWIA')
        },
        lineTitle: {
            className:
                _.get(lobData_TWIA, 'homeOwners.baseCoveragesTotal_TWIA') !== undefined
                    ? styles.spansytleleft : styles.spansytle
        },
        totalAddlCovPremium: {
            visible:
                _.get(lobData_TWIA, 'homeOwners.additionalCoveragesTotal_TWIA') !== undefined,
            value: _.get(lobData_TWIA, 'homeOwners.additionalCoveragesTotal_TWIA')
        },
        additionalTitle: {
            className:
                _.get(lobData_TWIA, 'homeOwners.additionalCoveragesTotal_TWIA') !== undefined
                    ? styles.spansytleleft : styles.spansytle
        },
        totalIndirectCovPremium: {
            visible:
                _.get(lobData_TWIA, 'homeOwners.indirectLossCoveragesTotal_TWIA') !== undefined,
            value: _.get(lobData_TWIA, 'homeOwners.indirectLossCoveragesTotal_TWIA')
        },
        indirectLossTitle: {
            className:
                _.get(lobData_TWIA, 'homeOwners.indirectLossCoveragesTotal_TWIA') !== undefined
                    ? styles.spansytleleft : styles.spansytle
        },
        totalCreditCovPremium: {
            visible:
                _.get(lobData_TWIA, 'homeOwners.creditsAndSurchagesTotal_TWIA') !== undefined,
            value: _.get(lobData_TWIA, 'homeOwners.creditsAndSurchagesTotal_TWIA')
        },
        creditTitle: {
            className:
                _.get(lobData_TWIA, 'homeOwners.creditsAndSurchagesTotal_TWIA') !== undefined
                    ? styles.spansytleleft : styles.spansytle
        },
        totalExclCovPremium: {
            visible:
                _.get(lobData_TWIA, 'homeOwners.exclusionsTotal_TWIA') !== undefined,
            value: _.get(lobData_TWIA, 'homeOwners.exclusionsTotal_TWIA')
        },
        exclusionTitle: {
            className:
                _.get(lobData_TWIA, 'homeOwners.exclusionsTotal_TWIA') !== undefined
                    ? styles.spansytleleft : styles.spansytle
        },
        indirectLossCoveragesTitle: {
            visible: _.get(lobData_TWIA, 'homeOwners.indirectLossCoverages_TWIA')?.length > 0
        },
        premium: {
            visible: true // DE15834

        },
        totalPremium: {
            value: {
                amount: _.get(policyDetailsData, 'latestPeriod.totalCost.amount'),
                currency: "USD"
            }
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            clausesComponentVM: ClausesComponentVM,
        },
        resolveCallbackMap: {
            // handleValueChange,
            // handleValueChangeAndSync,
            renderCreditName: renderNameField,
            renderCreditValue: renderValueField
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            // eslint-disable-next-line camelcase
            model={lobData_TWIA}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

CoveragesAccordion.propTypes = {
    data: PropTypes.shape({}),
};

export default CoveragesAccordion;
